import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'

import { ENV_CONFIG } from '../constants/envConfig'

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: ENV_CONFIG.CONSUMER_GATEWAY_URL,
    withCredentials: true,
    headers: {
      'X-IBX-Client-Platform': 'web',
      'X-IBX-Client-ID': 'io.instabox.consumer',
    },
    validateStatus(status) {
      // Axios considers 3xx status codes as "errored" ones
      // This is why we are having this custom status validator
      return status >= 100 && status < 400
    },
  })

  instance.interceptors.request.use(
    config => {
      config.headers['X-IBX-Correlation-ID'] = uuidv4()
      return config
    },
    error => {
      return Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    response => response,
    error => Promise.reject(error),
  )

  return instance
}

const instance = createAxiosInstance()

export default instance
